import Vue from "vue";
import Vuex from "vuex";
// THIS IS THE MASTER JSON PROJECT LIST
import projects from "@/assets/projects.json";

let Projects = projects.Projects.filter(item => item.Show);
let heroImages = Projects.map(item => item.id);
// [...Projects.keys()]
//  Projects.map(item => item.id);

function array_move(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  // return func; // for testing
}

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    projects: Projects,
    selectedProjectId: 0,
    selectedProjectKey: 0,
    heroImages: heroImages,
    activeProject: {},
    isMobile: true,
    loaded: false,
    firstLoad: true
  },
  getters: {
    numProjects: state => {
      return state.projects.length;
    },
    projectsByType: state => projectType => {
      return state.projects.filter(obj => {
        if (obj.Type === projectType) {
          return obj;
        }
      });
    },
    captions: state => {
      return state.activeProject.Captions;
    }
  },
  mutations: {
    setSelected(state, id) {
      state.activeProject = state.projects.find(item => item.id === id);
    },
    imageFlip(state, item) {
      let oldInd = state.heroImages.indexOf(item.id);
      let key = state.projects.indexOf(item);
      array_move(state.heroImages, oldInd, 0);
      state.selectedProjectKey = key;
      state.selectedProjectId = item.id;
      state.activeProject = item;
    }
  },
  actions: {}
});
